import { useCallback } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { parseBoardSearch, type BoardSearch } from "@/components/board/search";
import { WorkspaceBoard } from "@/components/board/workspace-board";

export const Route = createFileRoute("/_app/$workspaceSlug/board")({
  // The filters live in the URL and nowhere else. Whatever the URL says,
  // this returns a board that can be drawn: it never throws.
  validateSearch: (search: Record<string, unknown>): BoardSearch => parseBoardSearch(search),
  component: BoardRoute,
});

function BoardRoute() {
  const { workspaceSlug } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const setSearch = useCallback(
    (next: BoardSearch) => void navigate({ search: next, replace: true }),
    [navigate],
  );
  return <WorkspaceBoard key={workspaceSlug} search={search} onSearchChange={setSearch} />;
}
